export default __webpack_public_path__ + "static/media/smoke_free.ad85f15f.svg";